import { Component, Vue } from 'vue-property-decorator';
import I18n from '@/i18n/I18n';
import I18nHandler from '@/language/handlers/I18nHandler';
import Language from '@/language/Language';
import LanguageFactory from '@/language/LanguageFactory';
import LocalizedHTMLTagHandler from '@/language/handlers/LocalizedHTMLTagHandler';
import LocalizedLocationsHandler from '@/language/handlers/LocalizedLocationsHandler';
import LocalizedRouteHandler from '@/language/handlers/LocalizedRouteHandler';

@Component
export default class ChangeLanguage extends Vue {
    protected languageFactory!: LanguageFactory;

    created(): void {
        this.languageFactory = new LanguageFactory();
    }

    protected get currentLanguage(): Language {
        return this.languageFactory.createFrom(I18n);
    }

    protected set currentLanguage(language: Language) {
        const localizedLocationsHandler = new LocalizedLocationsHandler();
        const localizedRouteHandler = new LocalizedRouteHandler(localizedLocationsHandler);
        const localizedHTMLTagHandler = new LocalizedHTMLTagHandler(localizedRouteHandler);
        const i18nHandler = new I18nHandler(localizedHTMLTagHandler);

        i18nHandler.handle(language);
    }
}
